import React, { useEffect } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import { posthog, type PostHogConfig } from 'posthog-js';

const posthogOptions: Partial<PostHogConfig> = {
  api_host: process.env.POSTHOG_HOST,
  disable_session_recording: true,
};

type Props = {
  children: React.ReactNode;
  user?: { id: string; attributes: any };
};

export default function FeatureProvider({ user, children }: Props) {
  useEffect(() => {
    if (user && user.id) {
      posthog.identify(user.id, user.attributes);
    }
  }, [!user]);
  return (
    <PostHogProvider apiKey={process.env.POSTHOG_KEY!} options={posthogOptions}>
      {children}
    </PostHogProvider>
  );
}
